import React from 'react';

import classNames from 'classnames';
import CSSModules from 'react-css-modules';

import {CrossIcon, TickIcon} from '../../icons';
import ReadyIcon from '../../ReadyIcon';

import styles from './styles.module.scss';

type LabelProps = {
  label: string;
  htmlFor: string;
  optionalText?: string;
  dataAutomation?: string;
  readyStatusDataAutomation?: string;
  isLabelVisible?: boolean;
  validationStyle?: 'none' | 'icon';
  isInvalid?: boolean;
  showValidation?: boolean;

  /** @deprecated */
  useLegacyIcons?: boolean;
};

const getValidationIcon = (
  validationArgs:
    | {isInvalid: boolean; useLegacyIcons: true; dataAutomation?: string}
    | {isInvalid: boolean; useLegacyIcons: false}
) => {
  if (validationArgs.useLegacyIcons) {
    return (
      <ReadyIcon
        isValid={!validationArgs.isInvalid}
        size='small'
        dataAutomation={validationArgs.dataAutomation}
      />
    );
  }

  if (validationArgs.isInvalid) {
    return <CrossIcon colour='errorPrimary' size='xsmall' />;
  }
  return <TickIcon colour='successPrimary' size='xsmall' />;
};

const Label = ({
  label,
  htmlFor,
  optionalText,
  dataAutomation,
  readyStatusDataAutomation,
  isLabelVisible = true,
  validationStyle = 'none',
  showValidation = false,
  isInvalid = false,
  useLegacyIcons = false,
}: LabelProps) => (
  <label
    htmlFor={htmlFor}
    styleName='label'
    className={`${!isLabelVisible ? 'visually-hidden' : ''}`}
    data-automation={dataAutomation}
  >
    {validationStyle === 'icon' && showValidation && (
      <span
        styleName={classNames('icon-wrapper', {legacy: useLegacyIcons})}
        data-automation={readyStatusDataAutomation}
      >
        {getValidationIcon({
          isInvalid,
          dataAutomation: readyStatusDataAutomation,
          useLegacyIcons,
        })}
      </span>
    )}
    {label}
    {optionalText && <p styleName='optional-text'>{optionalText}</p>}
  </label>
);

export default CSSModules(Label, styles, {allowMultiple: true});
